export const END_OF_SERVICE_REASONS = [
  { value: 'resignation', label: 'Resignation' },
  { value: 'retirement', label: 'Retirement' },
  { value: 'termination', label: 'Termination' },
  { value: 'layoff', label: 'Layoff / Position Elimination' },
  { value: 'end_of_term', label: 'End of Contract / Term' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'volunteer_end', label: 'End of Volunteer Service' },
  { value: 'death', label: 'Death' },
  { value: 'other', label: 'Other' },
  { value: 'unknown', label: 'Unknown / Not Specified' },
] as const;

export type EndOfServiceReason = (typeof END_OF_SERVICE_REASONS)[number]['value'];
